import { ReactNode } from 'react';
import { useScrollReveal } from '@/hooks/use-scroll-reveal';
import { cn } from '@/lib/utils';

type Direction = 'up' | 'down' | 'left' | 'right' | 'fade' | 'zoom';

interface RevealProps {
  children: ReactNode;
  direction?: Direction;
  delay?: number;
  className?: string;
  as?: 'div' | 'section' | 'article' | 'li';
}

const hiddenMap: Record<Direction, string> = {
  up: 'opacity-0 translate-y-8',
  down: 'opacity-0 -translate-y-8',
  left: 'opacity-0 translate-x-8',
  right: 'opacity-0 -translate-x-8',
  fade: 'opacity-0',
  zoom: 'opacity-0 scale-95',
};

export function Reveal({
  children,
  direction = 'up',
  delay = 0,
  className,
  as: Tag = 'div',
}: RevealProps) {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>();

  return (
    <Tag
      ref={ref as never}
      style={{ transitionDelay: `${delay}ms` }}
      className={cn(
        'transition-all duration-700 ease-out will-change-transform',
        isVisible ? 'opacity-100 translate-x-0 translate-y-0 scale-100' : hiddenMap[direction],
        className
      )}
    >
      {children}
    </Tag>
  );
}
